import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { clinicalAlertService } from '../clinicalAlertService';

export function useClinicalAlerts() {
  return useQuery({
    queryKey: ['clinical-alerts'],
    queryFn: () => clinicalAlertService.getAll(),
    staleTime: 30000,
  });
}

export function useActiveClinicalAlerts() {
  return useQuery({
    queryKey: ['clinical-alerts', 'active'],
    queryFn: () => clinicalAlertService.getActive(),
    staleTime: 30000,
  });
}

export function useCreateClinicalAlert() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: clinicalAlertService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clinical-alerts'] });
    },
  });
}

export function useUpdateClinicalAlert() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) => clinicalAlertService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clinical-alerts'] });
    },
  });
}

export function useDeleteClinicalAlert() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: clinicalAlertService.remove,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clinical-alerts'] });
    },
  });
}
